<template>
  <!-- Modal producto -->
  <div class="modal fade" id="productoModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">

        <div class="modal-header pb-2">
          <div v-if="producto" style="min-width:0">
            <h5 class="modal-title fs-15 fw-semibold text-title mb-1 text-truncate">{{ producto.nombre }}</h5>
            <div class="d-flex gap-2 flex-wrap">
              <span v-if="producto.talla && producto.talla !== 'Sin Especificar'" class="talla-badge" :class="tallaCls(producto.talla)">{{ producto.talla }}</span>
              <span v-if="producto.linea"     class="info-tag">{{ producto.linea }}</span>
              <span v-if="producto.grupo"     class="info-tag">{{ producto.grupo }}</span>
              <span v-if="producto.codbarras" class="info-tag font-monospace">{{ producto.codbarras }}</span>
            </div>
          </div>
          <button type="button" class="btn-close p-0 ms-auto flex-shrink-0" data-bs-dismiss="modal">
            <img src="../../../assets/img/icons/close-circle-2.svg" alt="Cerrar" />
          </button>
        </div>

        <div class="modal-body pt-3 pb-0">
          <template v-if="producto">

            <!-- Tarjetas de stock -->
            <div class="row g-2 mb-3">
              <div class="col-4">
                <div class="stock-card text-center p-3">
                  <div class="stock-num" :class="numCls(producto.stock_t1)">{{ fmt(producto.stock_t1) }}</div>
                  <div class="stock-label">Lapoint <strong>939</strong></div>
                </div>
              </div>
              <div class="col-4">
                <div class="stock-card text-center p-3">
                  <div class="stock-num" :class="numCls(producto.stock_t2)">{{ fmt(producto.stock_t2) }}</div>
                  <div class="stock-label">Lapoint <strong>1179</strong></div>
                </div>
              </div>
              <div class="col-4">
                <div class="stock-card total text-center p-3">
                  <div class="stock-num text-purple">{{ fmt(producto.stock_total) }}</div>
                  <div class="stock-label"><strong>Stock total</strong></div>
                </div>
              </div>
            </div>

            <!-- Info rápida -->
            <div class="d-flex flex-wrap gap-2 mb-3">
              <div class="info-pill">
                <span class="lbl">Precio venta</span>
                <span class="val text-purple fw-semibold">S/ {{ Number(producto.precvta).toFixed(2) }}</span>
              </div>
              <div v-if="producto.costo > 0" class="info-pill">
                <span class="lbl">Costo</span>
                <span class="val">S/ {{ Number(producto.costo).toFixed(2) }}</span>
              </div>
              <div v-if="producto.modelo" class="info-pill">
                <span class="lbl">Modelo</span>
                <span class="val font-monospace">{{ producto.modelo }}</span>
              </div>
              <div v-if="producto.codigo_prov" class="info-pill">
                <span class="lbl">Cód. Prov.</span>
                <span class="val font-monospace">{{ producto.codigo_prov }}</span>
              </div>
              <div class="info-pill">
                <span class="lbl">Stock mín.</span>
                <span class="val">{{ producto.stockminimo }}</span>
              </div>
            </div>

            <!-- Tabs -->
            <ul class="nav nav-tabs mb-0">
              <li class="nav-item"><button class="nav-link fs-13 px-3 py-2" :class="{active:tab==='detalle'}" @click="tab='detalle'">Detalles</button></li>
              <li class="nav-item">
                <button class="nav-link fs-13 px-3 py-2" :class="{ active: tab === 'kardex' }" @click="tab='kardex'">
                  Kardex
                  <span v-if="kardexTotal" class="badge bg-light text-secondary ms-1 fw-normal">{{ kardexTotal }}</span>
                </button>
              </li>
            </ul>

            <div v-if="tab==='detalle'" class="py-3">
              <div v-if="detalleLoading" class="text-center py-4"><span class="spinner-border spinner-border-sm"></span></div>
              <div v-else class="detail-grid">
                <div><small>Línea principal</small><strong>{{ detalle.superlinea || '—' }}</strong></div>
                <div><small>Sub línea</small><strong>{{ detalle.linea || '—' }}</strong></div>
                <div><small>Marca</small><strong>{{ detalle.grupo || '—' }}</strong></div>
                <div><small>Género / talla</small><strong>{{ detalle.talla || 'Sin especificar' }} · {{ detalle.usa || detalle.peru || '—' }}</strong></div>
                <div><small>Cód. proveedor</small><strong>{{ detalle.codigo_prov || '—' }}</strong></div>
                <div><small>Modelo</small><strong>{{ detalle.modelo || '—' }}</strong></div>
                <div><small>Stock mínimo / máximo</small><strong>{{ detalle.stockminimo || 0 }} / {{ detalle.stockmaximo || 0 }}</strong></div>
                <div><small>Tipo</small><strong>{{ ['','Producto terminado','Insumo','Servicio'][detalle.tipoprod] || '—' }}</strong></div>
                <div v-for="p in detalle.presentaciones || []" :key="p.idpres" class="detail-presentation">
                  <small>Presentación {{ p.tipopres }}</small><strong>{{ p.nombre || 'UNIDAD' }} · {{ p.codbarras || 'Sin barcode' }} · S/ {{ Number(p.precvta||0).toFixed(2) }}</strong>
                </div>
                <div v-if="detalle.detalletecnico" class="detail-wide"><small>Detalle técnico</small><strong>{{ detalle.detalletecnico }}</strong></div>
                <div v-if="detalle.observacion" class="detail-wide"><small>Observación</small><strong>{{ detalle.observacion }}</strong></div>
                <section class="locations detail-wide">
                  <div class="locations-title"><div><small>UBICACIÓN FÍSICA</small><strong>Andamios por sede</strong></div><span>Para encontrar el producto rápidamente</span></div>
                  <div v-if="ubicacionesLoading" class="text-center py-3"><span class="spinner-border spinner-border-sm"></span></div>
                  <div v-else-if="!ubicaciones.length" class="text-muted fs-13 py-2">Este producto todavía no tiene registro de stock por almacén.</div>
                  <div v-else class="location-list">
                    <div v-for="u in ubicaciones" :key="u.idalmacen" class="location-row">
                      <div class="location-warehouse"><strong>{{ nombreSede(u) }}</strong><small>Stock: {{ fmt(u.stockfisico) }}</small></div>
                      <input v-model.trim="u.ubicacion" maxlength="40" placeholder="Ej: Andamio 3, CD5" aria-label="Ubicación física">
                      <label class="location-all" :title="`Aplica esta ubicación a todas las tallas de ${detalle.codigo_prov || 'este producto'} en esta sede`"><input v-model="u.aplicarTodas" type="checkbox"> Todas las tallas</label>
                      <button class="btn btn-sm btn-outline-primary" :disabled="u.saving" @click="guardarUbicacion(u)">{{ u.saving ? 'Guardando...' : 'Guardar' }}</button>
                    </div>
                  </div>
                  <div v-if="ubicacionMensaje" class="location-message" :class="ubicacionError ? 'text-danger' : 'text-success'">{{ ubicacionMensaje }}</div>
                </section>
              </div>
            </div>

            <!-- Kardex -->
            <div v-else class="py-3">
              <div v-if="kardexLoading" class="text-center py-4">
                <div class="spinner-border spinner-border-sm text-purple" role="status"></div>
              </div>
              <div v-else-if="!kardex.length" class="text-center text-muted py-4 fs-14">
                Sin movimientos registrados.
              </div>
              <div v-else>
                <div class="kardex-toolbar">
                  <span class="kardex-filter-label">Ver movimientos de:</span>
                  <div class="sede-segment" role="group" aria-label="Filtrar Kardex por sede">
                    <button v-for="sede in sedesKardex" :key="sede.value" type="button"
                      :class="{ active: kardexSede === sede.value }" @click="kardexSede = sede.value">
                      {{ sede.label }}
                    </button>
                  </div>
                  <span class="kardex-visible-count">{{ kardexVisible.length }} en esta página</span>
                </div>
                <div v-if="!kardexVisible.length" class="text-center text-muted py-4 fs-13">
                  No hay movimientos de esta sede en la página actual.
                </div>
                <div v-else class="table-responsive">
                <table class="table table-sm align-middle mb-0 fs-13">
                  <thead>
                    <tr class="kardex-head">
                      <th>FECHA</th>
                      <th>TIPO</th>
                      <th>DOCUMENTO</th>
                      <th>RUTA DEL MOVIMIENTO</th>
                      <th class="text-end">CANT.</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="m in kardexVisible" :key="`${m.presentacionid}-${m.fecha}-${m.detalle}-${m.tipo}`" class="kardex-row">
                      <td class="text-muted">{{ fmtFecha(m.fecha) }}</td>
                      <td>
                        <span class="mov-badge" :class="`mov-${movInfo(m).clase}`">
                          {{ movInfo(m).icono }} {{ movInfo(m).etiqueta }}
                        </span>
                      </td>
                      <td>
                        <button v-if="movInfo(m).esVenta"
                          class="doc-link"
                          @click="abrirVenta(m.detalle)"
                          :title="`Ver detalle de ${m.detalle}`">
                          {{ m.detalle }}
                          <span class="doc-link-arrow">↗</span>
                        </button>
                        <span v-else class="font-monospace text-muted">{{ m.detalle }}</span>
                        <small class="doc-context">{{ docContexto(m) }}</small>
                      </td>
                      <td>
                        <div class="route-cell" :class="{ 'route-transfer': movInfo(m).clase === 'traslado' }">
                          <span class="route-point">{{ ruta(m).origen }}</span>
                          <span class="route-arrow">→</span>
                          <span class="route-point route-destination">{{ ruta(m).destino }}</span>
                        </div>
                      </td>
                      <td class="text-end fw-semibold" :class="m.tipo === 1 ? 'text-danger' : 'text-success'">
                        {{ m.tipo === 1 ? '-' : '+' }}{{ Number(m.tipo === 1 ? m.sal_cantidad : m.ing_cantidad).toFixed(0) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                </div>
              </div>

              <!-- Paginación kardex -->
              <div v-if="kardexTotal > kardexPageSize" class="d-flex justify-content-between align-items-center pt-2 border-top mt-2">
                <span class="fs-12 text-muted">{{ kardexTotal.toLocaleString() }} movimientos · pág. {{ kardexPage }}</span>
                <div class="d-flex gap-1">
                  <button class="btn btn-sm style-six py-1 px-2 fs-12" :disabled="kardexPage === 1" @click="kardexPrev">‹ Ant.</button>
                  <button class="btn btn-sm style-six py-1 px-2 fs-12" :disabled="kardexPage * kardexPageSize >= kardexTotal" @click="kardexNext">Sig. ›</button>
                </div>
              </div>
            </div>

          </template>
          <div v-else class="text-center text-muted py-5">Selecciona un producto</div>
        </div>

        <div class="modal-footer pt-2">
          <button class="btn btn-primary me-auto" data-bs-dismiss="modal" @click="$emit('edit', detalle.idprod ? detalle : producto)">Modificar</button>
          <button class="btn style-six" data-bs-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Overlay de venta (Teleport evita problemas de z-index con modales anidados) -->
  <Teleport to="body">
    <Transition name="overlay-fade">
      <div v-if="ventaOverlay" class="venta-overlay" @click.self="cerrarVenta">
        <div class="venta-panel">
          <!-- Header -->
          <div class="venta-panel-header">
            <div>
              <div class="fs-14 fw-semibold text-title">Detalle de Venta</div>
              <div v-if="ventaDetalle" class="text-purple fs-13 mt-1">
                <span class="comp-badge" :class="compBadgeCls(ventaDetalle.comprobante)">
                  {{ compTipo(ventaDetalle.comprobante) }}
                </span>
                {{ ventaDetalle.comprobante }}
              </div>
            </div>
            <button class="venta-close-btn" @click="cerrarVenta" title="Cerrar">
              <img src="../../../assets/img/icons/close-circle-2.svg" alt="Cerrar" />
            </button>
          </div>

          <!-- Body -->
          <div class="venta-panel-body">
            <div v-if="ventaLoading" class="text-center py-5">
              <div class="spinner-border text-purple" role="status"></div>
            </div>
            <div v-else-if="ventaError" class="alert alert-danger fs-13 m-3">{{ ventaError }}</div>
            <template v-else-if="ventaDetalle">
              <div class="d-flex gap-3 flex-wrap px-3 pt-3 pb-2">
                <div class="info-pill"><span class="lbl">Fecha</span><span class="val">{{ fmtFecha(ventaDetalle.fecha) }}</span></div>
                <div class="info-pill"><span class="lbl">Almacén</span><span class="val">{{ ventaDetalle.almacen }}</span></div>
              </div>
              <div class="table-responsive px-3 pb-3">
                <table class="table table-sm align-middle fs-13 mb-0">
                  <thead><tr class="kardex-head">
                    <th>#</th><th>PRODUCTO</th><th>PRESENTACIÓN</th>
                    <th class="text-end">CANT.</th><th class="text-end">P.UNIT.</th><th class="text-end">SUBTOTAL</th>
                  </tr></thead>
                  <tbody>
                    <tr v-for="(item, i) in ventaDetalle.items" :key="item.id">
                      <td class="text-muted">{{ i + 1 }}</td>
                      <td class="fw-semibold">{{ item.producto }}</td>
                      <td class="text-muted">{{ item.presentacion }}</td>
                      <td class="text-end">{{ Number(item.cantidad).toFixed(0) }}</td>
                      <td class="text-end">S/ {{ Number(item.precio).toFixed(2) }}</td>
                      <td class="text-end fw-semibold">S/ {{ Number(item.subtotal).toFixed(2) }}</td>
                    </tr>
                    <tr>
                      <td colspan="4" class="border-0"></td>
                      <td class="fw-semibold text-end border-top pt-2">TOTAL</td>
                      <td class="fw-black text-purple text-end border-top pt-2 fs-15">S/ {{ Number(ventaDetalle.total).toFixed(2) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </div>

          <!-- Footer -->
          <div class="venta-panel-footer">
            <button class="btn style-six" @click="cerrarVenta">Cerrar</button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import api from '../../../services/api';
import { clasificarMovimientoKardex, contextoDocumentoKardex, rutaMovimientoKardex } from '../../../utils/kardexMovimiento';

export default {
  name: 'ProductoModal',
  props: { producto: { type: Object, default: null } },
  emits: ['edit'],
  data() {
    return {
      tab: 'kardex',
      detalle: {}, detalleLoading: false,
      ubicaciones: [], ubicacionesLoading: false, ubicacionMensaje: '', ubicacionError: false,
      kardex: [], kardexContexto: [], kardexTotal: 0, kardexPage: 1, kardexPageSize: 20, kardexLoading: false,
      kardexSede: '',
      sedesKardex: [
        { value: '', label: 'Todas' },
        { value: '939', label: 'Lapoint 939' },
        { value: '1179', label: 'Lapoint 1179' },
      ],
      ventaOverlay: false,
      ventaDetalle: null, ventaLoading: false, ventaError: null,
    };
  },
  watch: {
    producto(p) { if (p) { this.tab='kardex'; this.kardexPage = 1; this.kardexSede = ''; this.cargarDetalle(); this.cargarKardex(); } },
  },
  computed: {
    kardexVisible() {
      if (!this.kardexSede) return this.kardex;
      return this.kardex.filter((movimiento) => String(movimiento.almacen || '').includes(this.kardexSede));
    },
  },
  methods: {
    async cargarDetalle() {
      this.detalleLoading=true; this.ubicacionesLoading=true; this.ubicacionMensaje='';
      try {
        const [d,u]=await Promise.all([api.get(`/productos/${this.producto.idprod}`),api.get(`/productos/${this.producto.idprod}/ubicaciones`)]);
        this.detalle=d.data.data||{};
        this.ubicaciones=(u.data.data||[]).map(x=>({...x,ubicacion:x.ubicacion||'',aplicarTodas:false,saving:false}));
      } catch { this.detalle={...this.producto}; this.ubicaciones=[]; }
      finally { this.detalleLoading=false; this.ubicacionesLoading=false; }
    },
    nombreSede(u) { const n=String(u.almacen||''); if(n.includes('939')) return 'Lapoint 939'; if(n.includes('1179')) return 'Lapoint 1179'; return n||`Almacén ${u.idalmacen}`; },
    async guardarUbicacion(u) {
      u.saving=true; this.ubicacionMensaje=''; this.ubicacionError=false;
      try {
        await api.put(`/productos/${this.producto.idprod}/ubicaciones`,{idalmacen:u.idalmacen,ubicacion:u.ubicacion,aplicarTodas:u.aplicarTodas});
        this.ubicacionMensaje=u.aplicarTodas?'Ubicación aplicada a todas las tallas de esta sede.':'Ubicación guardada para esta talla y sede.';
      } catch(e) { this.ubicacionError=true; this.ubicacionMensaje=e.response?.data?.error||'No se pudo guardar la ubicación.'; }
      finally { u.saving=false; }
    },
    movInfo(movimiento) {
      return clasificarMovimientoKardex(movimiento);
    },
    ruta(movimiento) {
      return rutaMovimientoKardex(movimiento, this.kardexContexto);
    },
    docContexto(movimiento) {
      return contextoDocumentoKardex(movimiento);
    },
    async cargarKardex() {
      if (!this.producto) return;
      this.kardexLoading = true;
      try {
        const pageOffset = (this.kardexPage - 1) * this.kardexPageSize;
        const contextOffset = Math.max(0, pageOffset - 1);
        const res = await api.get(`/productos/${this.producto.idprod}/kardex`, {
          params: { limit: this.kardexPageSize + (pageOffset > 0 ? 2 : 1), offset: contextOffset },
        });
        this.kardexContexto = res.data.data || [];
        const inicio = pageOffset > 0 ? 1 : 0;
        this.kardex = this.kardexContexto.slice(inicio, inicio + this.kardexPageSize);
        this.kardexTotal = res.data.pagination?.total || 0;
      } catch { this.kardex = []; this.kardexContexto = []; } finally { this.kardexLoading = false; }
    },
    kardexPrev() { this.kardexPage--; this.cargarKardex(); },
    kardexNext() { this.kardexPage++; this.cargarKardex(); },

    async abrirVenta(comprobante) {
      this.ventaDetalle = null;
      this.ventaError   = null;
      this.ventaLoading = true;
      this.ventaOverlay = true;
      try {
        const res = await api.get(`/ventas/${encodeURIComponent(comprobante)}`);
        this.ventaDetalle = res.data.data;
      } catch (e) {
        this.ventaError = e.response?.data?.error || 'Error al cargar la venta';
      } finally {
        this.ventaLoading = false;
      }
    },
    cerrarVenta() {
      this.ventaOverlay = false;
      this.ventaDetalle = null;
      this.ventaError   = null;
    },

    compTipo(c) {
      if (!c) return '';
      if (c.startsWith('F')) return 'Factura';
      if (c.startsWith('B')) return 'Boleta';
      return 'Ticket';
    },
    compBadgeCls(c) {
      if (!c) return '';
      if (c.startsWith('F')) return 'cb-factura';
      if (c.startsWith('B')) return 'cb-boleta';
      return 'cb-ticket';
    },

    fmtFecha(f) {
      if (!f) return '—';
      const s = String(f).substring(0, 10); return new Date(s + 'T00:00:00').toLocaleDateString('es-PE', { day:'2-digit', month:'2-digit', year:'numeric' });
    },
    fmt(v)  { const n = parseFloat(v)||0; return n%1===0 ? n.toFixed(0) : n.toFixed(1); },
    numCls(v) { const n=parseFloat(v)||0; return n===0?'text-danger':n<=2?'text-warning':'text-success'; },
    tallaCls(t) {
      return {Caballero:'tc-c',Dama:'tc-d',Niño:'tc-n',Niña:'tc-n',Infante:'tc-n',
              'Unisex (adultos)':'tc-u','Unisex (niños)':'tc-u'}[t]||'';
    },
  },
};
</script>

<style scoped>
.stock-card  { background:#f8fafc; border:1px solid #e8edf2; border-radius:10px; }
.stock-card.total { background:#f5f3ff; border-color:#ddd6fe; }
.stock-num   { font-size:28px; font-weight:900; line-height:1; }
.stock-label { font-size:12px; color:#888; margin-top:4px; }

.info-pill   { display:inline-flex; align-items:center; gap:6px; padding:4px 10px; background:#f8fafc; border-radius:6px; border:1px solid #eee; }
.info-pill .lbl { font-size:11px; color:#888; }
.info-pill .val { font-size:13px; font-weight:500; }

.info-tag    { display:inline-block; padding:2px 8px; background:#f1f5f9; border-radius:4px; font-size:12px; color:#555; }
.detail-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px}.detail-grid>div{padding:10px;border:1px solid #e5e7eb;background:#f8fafc;border-radius:6px}.detail-grid small,.detail-grid strong{display:block}.detail-grid small{color:#64748b;margin-bottom:4px}.detail-grid strong{font-size:13px;color:#1e293b}.detail-presentation,.detail-wide{grid-column:1/-1}@media(max-width:700px){.detail-grid{grid-template-columns:1fr}}
.locations{background:#fff!important;padding:14px!important}.locations-title{display:flex;align-items:end;justify-content:space-between;margin-bottom:10px}.locations-title>span{font-size:11px;color:#64748b}.location-list{display:grid;gap:8px}.location-row{display:grid;grid-template-columns:minmax(130px,1fr) minmax(180px,2fr) auto auto;align-items:center;gap:10px;padding:9px;border:1px solid #e2e8f0;border-radius:6px;background:#f8fafc}.location-warehouse small{display:block;color:#64748b}.location-row>input{width:100%;border:1px solid #cbd5e1;border-radius:5px;padding:8px 10px;font-size:13px}.location-all{display:flex;align-items:center;gap:5px;font-size:12px;white-space:nowrap}.location-message{font-size:12px;font-weight:600;margin-top:8px}@media(max-width:760px){.location-row{grid-template-columns:1fr}.locations-title{align-items:start;flex-direction:column;gap:3px}}

.talla-badge { display:inline-block; padding:2px 8px; border-radius:4px; font-size:12px; font-weight:500; }
.tc-c { background:#dbeafe; color:#1d4ed8; }
.tc-d { background:#fce7f3; color:#be185d; }
.tc-n { background:#fef3c7; color:#92400e; }
.tc-u { background:#ede9fe; color:#6d28d9; }

.kardex-head th { font-size:11px; font-weight:600; color:#888; text-transform:uppercase; letter-spacing:.4px; border-bottom:2px solid #f0f4f8; }
.kardex-row td  { border-bottom:1px solid #f5f7fa; padding-top:6px; padding-bottom:6px; }
.kardex-row:hover td { background:#fafbff; }

.mov-badge  { display:inline-block; padding:2px 7px; border-radius:4px; font-size:11px; font-weight:500; }
.mov-entrada{ background:#dcfce7; color:#15803d; }
.mov-salida { background:#fee2e2; color:#dc2626; }
.mov-venta  { background:#fee2e2; color:#dc2626; }
.mov-traslado { background:#fef3c7; color:#92400e; }

.doc-link { background:none; border:none; padding:0; font-size:13px; font-family:monospace; color:#4f46e5; cursor:pointer; text-decoration:underline; text-decoration-style:dotted; display:inline-flex; align-items:center; gap:3px; }
.doc-link:hover { color:#3730a3; }
.doc-link-arrow { font-size:11px; opacity:.6; }
.doc-context { display:block; margin-top:2px; color:#94a3b8; font-size:10px; }
.route-cell { display:flex; align-items:center; gap:6px; min-width:190px; font-size:12px; }
.route-point { color:#475569; font-weight:600; white-space:nowrap; }
.route-destination { color:#166534; }
.route-arrow { color:#94a3b8; font-size:14px; }
.route-transfer { padding:4px 7px; border:1px solid #fde68a; background:#fffbeb; border-radius:4px; }
.kardex-toolbar { display:flex; align-items:center; gap:10px; flex-wrap:wrap; margin-bottom:10px; }
.kardex-filter-label, .kardex-visible-count { color:#64748b; font-size:12px; }
.kardex-visible-count { margin-left:auto; }
.sede-segment { display:inline-flex; border:1px solid #cbd5e1; border-radius:6px; overflow:hidden; }
.sede-segment button { border:0; border-right:1px solid #cbd5e1; background:#fff; color:#475569; padding:5px 10px; font-size:12px; font-weight:600; }
.sede-segment button:last-child { border-right:0; }
.sede-segment button.active { background:#4f46e5; color:#fff; }

/* ── Overlay de venta ────────────────────────────────────────────────────── */
.venta-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.55);
  z-index: 1080;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.venta-panel {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0,0,0,.25);
}

.venta-panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px 20px 12px;
  border-bottom: 1px solid #f0f4f8;
  flex-shrink: 0;
}

.venta-close-btn {
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  opacity: .7;
  flex-shrink: 0;
}
.venta-close-btn:hover { opacity: 1; }

.venta-panel-body {
  overflow-y: auto;
  flex: 1;
}

.venta-panel-footer {
  padding: 12px 20px;
  border-top: 1px solid #f0f4f8;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}

.comp-badge { display:inline-block; padding:1px 7px; border-radius:4px; font-size:11px; font-weight:500; margin-right:4px; }
.cb-boleta  { background:#dbeafe; color:#1d4ed8; }
.cb-factura { background:#dcfce7; color:#15803d; }
.cb-ticket  { background:#fef3c7; color:#92400e; }

/* Transición */
.overlay-fade-enter-active, .overlay-fade-leave-active { transition: opacity .18s ease; }
.overlay-fade-enter-from, .overlay-fade-leave-to { opacity: 0; }
.overlay-fade-enter-active .venta-panel, .overlay-fade-leave-active .venta-panel { transition: transform .18s ease; }
.overlay-fade-enter-from .venta-panel { transform: translateY(12px); }
.overlay-fade-leave-to .venta-panel { transform: translateY(8px); }

.fs-15 { font-size: 15px; }
</style>
